/**
 * Menu.js
 */

import $ from 'jquery';
import { gsap } from 'gsap';

export default class Menu {

  constructor() {
    this.headerHeight = $('.header-navigation').outerHeight();
    this.lastScrollTop = 0;
    this.threshold = 10;

    this.mobileNavLinks = $('.mobile-nav-item');
    this.mobileNavSkrim = $('.mobile-nav-skrim')
    this.hamburger = $('.menu-nav');
    this.close = $('.menu-close');
    this.jumpNav = $('.mobile-jump-nav');
    this.navLinks = $('.nav-link, .home-link');
    this.mobileNavLinks.on('click', this.mobileNavClick.bind(this))
    this.navLinks.on('click', this.selectNavLink)
    this.hamburger.on('click', this.toggleMenu)
    this.close.on('click', this.toggleMenu)
    this.jumpNav.on('click', this.toggleJumpNav);
    this.mobileNavSkrim.on('click', this.toggleMenu);

    $(document).on('mouseup', (e) => {
      var container = $('.desktop-nav-inner');
      if (!container.is(e.target) && container.has(e.target).length === 0 && window.innerWidth >= 1024) {
        this.closeMenu();
      }
    });

    window.addEventListener('scroll', this.handleScroll.bind(this));
  }

  mobileNavClick(e) {
    this.mobileNavLinks.removeClass('current-page text-orange')
    const $activeLink = $(e.target).parents('.mobile-nav-item');
    $activeLink.addClass('current-page');
    gsap.delayedCall(0.5, this.toggleMenu);
  }

  scrollReveal() {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > this.lastScrollTop + this.threshold) {
      $('body').removeClass('reveal-nav')
    } else {
      var diff = Math.abs($(window).scrollTop() - this.lastScrollTop);
      if (diff > this.threshold) {
        $('body').addClass('reveal-nav')
      }
    }
    this.lastScrollTop = st <= 0 ? 0 : st;
  }

  scrollPageNav() {
    if ( $('.program-navigation').length < 1) {
      return;
    }

    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > $('.program-navigation').offset().top + $('.program-navigation').outerHeight()) {
      $('body').addClass('show-jump-nav');
    } else {
      $('body').removeClass('show-jump-nav');
    }
  }

  selectNavLink(e) {
    $('.nav-link.current-page').removeClass('current-page');
    // $(this).addClass('current-page');
  }

  toggleJumpNav() {
    $('.mobile-jump-nav').addClass('jump-nav-active');
  }

  toggleMenu() {
    $('body').hasClass('menu-active') ? $('body').removeClass('menu-active') : $('body').addClass('menu-active');
  }

  closeMenu() {
    $('.site-header').removeClass('desktop-menu-active')
    $('.mobile-menu').removeClass('menu-active')
    $('body').removeClass('modal-open');
  }

  checkNavScroll() {
    let headerPosition = window.innerWidth < 1024 ? 0 : this.headerHeight;

    if (document.body.scrollTop > headerPosition || document.documentElement.scrollTop > headerPosition) {
      $('body').addClass('nav-scrolled')
      $('.top-ad-wrapper').css('margin-bottom', this.headerHeight);
    } else {
      $('body').removeClass('nav-scrolled');
      $('.top-ad-wrapper').css('margin-bottom', 0);
    }
  }

  handleScroll() {
    this.scrollPageNav();
    this.checkNavScroll();
    this.scrollReveal();
  }
}
